import { tokens } from '../../tokens';

interface Props {
  label: string;
  value: string;
  color?: string;
  big?: boolean;
}

const DeepRow = ({
  label,
  value,
  color = tokens.textPrimary,
  big = false,
}: Props) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'space-between',
      padding: '8px 0',
      borderBottom: '1px solid rgba(255,255,255,0.05)',
    }}
  >
    <span
      style={{
        fontSize: 11,
        color: tokens.textSecondary,
        fontFamily: tokens.fontMono,
        letterSpacing: '0.15em',
        fontWeight: 600,
        textTransform: 'uppercase',
      }}
    >
      {label}
    </span>
    <span
      style={{
        fontSize: big ? 22 : 14,
        fontFamily: big ? tokens.fontDisplay : tokens.fontMono,
        color,
        fontWeight: big ? 400 : 600,
        lineHeight: 1,
      }}
    >
      {value}
    </span>
  </div>
);

export default DeepRow;
